import React, { Component } from 'react';
import { connect } from 'react-redux';
import OrderOnCallButton from '../Button/OrderOnCallButton';
import * as Validations from '../../utils/validations';

class AddEditCustomerAddress extends Component {
  constructor(props) {
    super(props);

    const { customerDetails, customerPincode } = this.props;

    this.state = {
      addressDetails: {
        contactName: customerDetails.status === 1 ? customerDetails.data.profile.name : '',
        flatNumber: '',
        streetName: '',
        pincode: customerPincode,
        contactNumber: customerDetails.status === 1 ? customerDetails.data.profile.mobileNumber : '',
        type: 0
      },
      errorMsg: ''
    };
  }
  setPatientName(value) {
    this.state.addressDetails.contactName = value;
    this.setState(this.state.addressDetails);
  }

  setFlatBldgNo(value) {
    this.state.addressDetails.flatNumber = value;
    this.setState(this.state.addressDetails);
  }

  setStreetName(value) {
    this.state.addressDetails.streetName = value;
    this.setState(this.state.addressDetails);
  }

  setPincode(value) {
    let errorMessage = '';
    if (!Validations.pincode(value)) {
      errorMessage = 'Pincode must be a 6 digit number';
    }
    this.state.addressDetails.pincode = value;
    this.setState({
      addressDetails: this.state.addressDetails,
      errorMsg: errorMessage,
    });
  }

  setMobileNo(value) {
    let errorMessage = '';
    if (!Validations.mobile(value)) {
      errorMessage = 'Mobile number must be 10 digit number';
    }
    this.state.addressDetails.contactNumber = value;
    this.setState({
      addressDetails: this.state.addressDetails,
      errorMsg: errorMessage,
    });
  }

  setAddressType(value) {
    this.state.addressDetails.type = value;
    this.setState(this.state.addressDetails);
  }

  saveAddress() {

    const { addressDetails } = this.state;

    if (Object.keys(addressDetails)
      .filter(key => { addressDetails[key] && addressDetails[key].length }).length > 0) {
      this.setState({ errorMsg: 'Cannot have empty fields' });
      return;
    }
    if (!Validations.mobile(addressDetails.contactNumber)) {
      this.setState({ errorMsg: 'Please Enter Valid Mobile Number' });
      return;
    }
    if (!Validations.pincode(addressDetails.pincode)) {
      this.setState({ errorMsg: 'Please Enter Valid Pincode' });
      return;
    }

    this.props.saveNewAddress(addressDetails);
  };

  componentWillMount() {
    if (this.props.addressDetails) {
      this.setState({ addressDetails: this.props.addressDetails });
    }
  }
  componentDidMount() {
    this.addressInput && this.addressInput.focus();
  }
  render() {
    const { loading, action } = this.props;
    const { contactName, flatNumber, streetName, pincode, contactNumber, type } = this.state.addressDetails;
    const { errorMsg } = this.state;
    const enabledRadio = 'https://pe-web-assets.s3.amazonaws.com/images/prescriptions/radio_button_enabled.svg';
    const disabledRadio = 'https://pe-web-assets.s3.amazonaws.com/images/prescriptions/radio_button_disabled.svg';
    return (
      <div>
        <div className="AddressFieldHeader">Patient Name</div>
        <input
          type="text"
          required
          pattern="[a-zA-Z][a-zA-Z ]*"
          className="AddressInput"
          ref={(input) => { this.addressInput = input; }}
          value={contactName}
          onChange={event => this.setPatientName(event.target.value)}/>
        <div className="AddressFieldHeader">Building Name and Flat Number</div>
        <textarea
          className="AddressInput"
          value={flatNumber}
          onChange={event => this.setFlatBldgNo(event.target.value)}/>
        <div className="AddressFieldHeader">Street Name</div>
        <textarea
          className="AddressInput"
          value={streetName}
          onChange={event => this.setStreetName(event.target.value)}/>
        <div className="AddressFieldHeader">Pincode</div>
        <input
          type="text"
          required
          pattern="[1-9][0-9]{6,6}"
          className="AddressInput"
          value={pincode}
          onChange={event => this.setPincode(event.target.value)}/>
        <div className="AddressFieldHeader">Mobile Number</div>
        <input
          type="text"
          required
          pattern="[16789][0-9]{9}"
          className="AddressInput"
          value={contactNumber}
          onChange={event => this.setMobileNo(event.target.value)}/>
        {errorMsg && <div className="errorMsg">{errorMsg}</div>}
        {action.data && action.data.status==0 && <div className="errorMsg">{action.data.error.message}</div>}
        <div style={{display: 'flex'}}>
          <div className="AddressFieldHeader">Address Type:</div>
          <div className="optionContainer">
            <img
              onClick={() => this.setAddressType(0)}
              className="radioButtonImage"
              src={type === 0 ? enabledRadio : disabledRadio}/>
            Home
          </div>
          <div className="optionContainer">
            <img
              onClick={() => this.setAddressType(1)}
              className="radioButtonImage"
              src={type === 1 ? enabledRadio : disabledRadio}/>
            Work
          </div>
          <div className="optionContainer">
            <img
              onClick={() => this.setAddressType(2)}
              className="radioButtonImage"
              src={type ===2 ? enabledRadio : disabledRadio}/>
            Other
          </div>
        </div>
        <div style={{ width: '25%' }}>
          <OrderOnCallButton
            type={1}
            text={loading ? 'Loading...' : 'Save' }
            onClickFunction={this.saveAddress.bind(this)}
          />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  customerDetails: state.customer.customerDetails,
  customerPincode: state.customer.selectedPincode,
}), null)(AddEditCustomerAddress);
